import * as React from "react";
import { forwardRef, ReactNode } from "react";

interface LabeledFieldProps {
  label: string;
  id: string;
  children: ReactNode;
  containerClassName?: string;
  className?: string;
  textColor?:
    | "primary"
    | "secondary"
    | "tertiary"
    | "white";
}

const LabeledField = forwardRef<HTMLDivElement, LabeledFieldProps>(
  (
    { label, id, children, className, containerClassName, textColor = "primary" },
    ref
  ) => {
    return (
      <div ref={ref} className={`${containerClassName}`}>
        <label
          htmlFor={id}
          className={`text-txt-md ${
            textColor === "primary"
              ? "text-primary"
              : textColor === "secondary"
              ? "text-secondary"
              : textColor === "tertiary"
              ? "text-tertiary"
              : textColor === "white"
              ? "text-white"
              : `text-text-${textColor}`
          } ${className}`}
        >
          {label}
        </label>
        {children}
      </div>
    );
  }
);

LabeledField.displayName = "LabeledField";

export default LabeledField;
